import { NavLink } from 'react-router-dom';

/**
 * Bottom navigation ala aplikasi mobile — 5 tujuan utama.
 * Tab aktif diberi warna gold; target sentuh tiap tab >= 56px tinggi.
 * Ikon digambar inline (stroke 24px grid) supaya tajam & bisa diwarnai.
 */

interface TabProps {
  to: string;
  label: string;
  children: (active: boolean) => React.ReactNode;
}

function Tab({ to, label, children }: TabProps) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className="flex min-h-[56px] flex-col items-center justify-center gap-1 pt-1"
    >
      {({ isActive }) => (
        <>
          {children(isActive)}
          <span
            className={`text-[10px] leading-none ${
              isActive ? 'font-bold text-brand-500' : 'font-medium text-neutral-500'
            }`}
          >
            {label}
          </span>
        </>
      )}
    </NavLink>
  );
}

/**
 * Warna ikon ikut status aktif. Dipakai sebagai class (bukan hex) supaya
 * ikut bertukar saat tema gelap/terang diganti.
 */
const tone = (active: boolean) => (active ? 'text-brand-500' : 'text-neutral-500');
const width = (active: boolean) => (active ? 2 : 1.9);

export function BottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-line/[0.07] bg-ink-950/95 backdrop-blur safe-bottom">
      <div className="mx-auto grid max-w-3xl grid-cols-5">
        <Tab to="/" label="Beranda">
          {(a) => (
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" className={tone(a)} stroke="currentColor" strokeWidth={width(a)} strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 10.2L12 3l9 7.2V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-9.8z" />
            </svg>
          )}
        </Tab>

        <Tab to="/eksplor" label="Eksplor">
          {(a) => (
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" className={tone(a)} stroke="currentColor" strokeWidth={width(a)} strokeLinecap="round">
              <circle cx="11" cy="11" r="7.5" />
              <path d="M21 21l-4.3-4.3" />
            </svg>
          )}
        </Tab>

        <Tab to="/jadwal" label="Jadwal">
          {(a) => (
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" className={tone(a)} stroke="currentColor" strokeWidth={width(a)} strokeLinecap="round">
              <rect x="3" y="5" width="18" height="16" rx="2.5" />
              <path d="M3 10h18M8 3v4M16 3v4" />
            </svg>
          )}
        </Tab>

        <Tab to="/favorites" label="Favorit">
          {(a) => (
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" className={tone(a)} stroke="currentColor" strokeWidth={width(a)} strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20.5l-1.4-1.3C5.4 14.5 2 11.4 2 7.6 2 4.9 4.1 3 6.7 3c1.6 0 3.1.8 4 2 .9-1.2 2.4-2 4-2C17.9 3 20 4.9 20 7.6c0 3.8-3.4 6.9-8.6 11.6l-1.4 1.3z" />
            </svg>
          )}
        </Tab>

        <Tab to="/profil" label="Profil">
          {(a) => (
            <svg width="21" height="21" viewBox="0 0 24 24" fill="none" className={tone(a)} stroke="currentColor" strokeWidth={width(a)} strokeLinecap="round">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" />
            </svg>
          )}
        </Tab>
      </div>
    </nav>
  );
}
